"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.readPubKey = exports.encryptPassword = void 0;
const consts_1 = require("../consts");
const subtle = globalThis.crypto.subtle;
function encryptPassword(password) {
    return __awaiter(this, void 0, void 0, function* () {
        const pubKey = yield readPubKey(consts_1.PASSWORD_PUBLIC_KEY);
        const enc = new TextEncoder();
        const encrypted = yield subtle.encrypt({
            name: 'RSA-OAEP'
        }, pubKey, enc.encode(password));
        const binaryStr = ab2str(encrypted);
        return btoa(binaryStr);
    });
}
exports.encryptPassword = encryptPassword;
function readPubKey(pem) {
    return __awaiter(this, void 0, void 0, function* () {
        const pemHeader = '-----BEGIN PUBLIC KEY-----';
        const pemFooter = '-----END PUBLIC KEY-----';
        const pemContents = pem.substring(pemHeader.length, pem.length - pemFooter.length - 1);
        const binaryDerString = atob(pemContents);
        const binaryDer = str2ab(binaryDerString);
        const key = yield subtle.importKey('spki', binaryDer, {
            name: 'RSA-OAEP',
            hash: 'SHA-1'
        }, true, ['encrypt']);
        return key;
    });
}
exports.readPubKey = readPubKey;
/*
Convert a string into an ArrayBuffer
from https://developers.google.com/web/updates/2012/06/How-to-convert-ArrayBuffer-to-and-from-String
*/
function str2ab(str) {
    const buf = new ArrayBuffer(str.length);
    const bufView = new Uint8Array(buf);
    for (let i = 0, strLen = str.length; i < strLen; i++) {
        bufView[i] = str.charCodeAt(i);
    }
    return buf;
}
function ab2str(buf) {
    const byteArray = new Uint8Array(buf);
    return String.fromCharCode(...byteArray);
}
